import Vue from "vue";
import {
  AssetService
} from "@/common/api.service";
import {
  FETCH_ASSETS
} from "./actions.type";
import {
  SET_ASSETS
} from "./mutations.type";

const initialState = {
  assets: []
};

export const state = { ...initialState };

export const actions = {
  async [FETCH_ASSETS](context) {
      console.log("va")
    // avoid extronuous network call if article exists
    const { data } = await AssetService.getAssets();
    console.log("1")
    context.commit(SET_ASSETS, data.payload);
    console.log("no")
    return data;
  }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
export const mutations = {
  [SET_ASSETS](state, assets) {
      console.log("2")
    state.assets = assets;
  }
};

const getters = {
  assets(state) {
    return state.assets;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
